export enum Permission {
  ApprovalsManagementView = 'approvals_management.view',
}
